<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-12 col-md-6">
          <h2>Detailed Analysis</h2>
        </div>
        <div class="col-12 col-md-6">
          <div class="rating-container float-md-right mb-3">
            <RateCapability :qAppId="qAppIdRatingValue"></RateCapability>
          </div>
        </div>
      </div>
      <br>

      <div class="row">
        <div class="col-12">
            <div class="alert alert-info">
                <div class="row">
                    <div class="col-12">
                        <b>Account status definitions</b>
                    </div>
                    <br>
                    <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                        <br>
                        Gained: had sales in current month(s), no sales in base month(s)
                        <br>
                        Gaining: sales increased in current month(s) by X%+ vs base month(s)
                        <br>
                        Stable: accounts not meeting other account status definitions
                        <br>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                        <br>
                        Losing: sales decreased in current month(s) by X%+ vs base month(s)
                        <br>
                        Lost: no sales in current month(s), had sales in base month(s)
                        <br>
                        Excluded: no sales in current and base months
                        <br>
                    </div>
                </div>
            </div>
          </div>
       </div>
      
      <div class="row mb-3">
        <div class="col-12 col-sm-12 col-md-3">
            <div class="q-filter" id="4e9b3947-41d4-4992-aeee-1ed9623f612f"></div>
        </div>
        <div class="col-12 col-sm-12 col-md-3">
            <div class="q-filter" id="8b73a37b-b234-4b79-924a-af23de77d4a2"></div>
        </div>
        <div class="col-12 col-sm-12 col-md-3">
            <div class="q-filter" id="15b36dd3-6c71-46fa-9e11-82d5419eb8c3"></div>
        </div>
        <div class="col-12 col-sm-12 col-md-3">
            <div class="q-filter" id="e80dc63b-7932-4185-80c0-a5355fb4548b"></div>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-12 col-sm-12 col-md-3">
            <div class="q-filter" id="2246f233-78d1-472a-a686-351b3fc8777e"></div>
        </div>
        <div class="col-12 col-sm-12 col-md-3">
            <div class="q-filter" id="3456adcb-1aea-4794-bd70-75e6c43579c4"></div>
        </div>
        <div class="col-12 col-sm-12 col-md-3">
            <div class="q-filter" id="a33e3b17-97a9-4db9-8690-c363346c30b8"></div>
        </div>
      </div>
        
      <div class="row" style="text-align: center;">
        <div class="col-12">
            <div style="color: red;">Each time franchise/platform/product selections are changed, please confirm your selection by clicking on the button below!</div>
        </div>
        <div class="col-12 mb-3 pt-3">
            <div class="q-filter h50" id="bfa1acaa-9377-4d78-a1cd-978b1d2492c5" noHeader="true" />
        </div>
      </div>
    
      <div class="row row-object pt-3 one-viz-row">
        <div class="col-12">
          <QlikViz vizId="ehLUKe" vizTitle="Detailed View by Customer" />
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-9">
            <div style="height: 100px;" id="49eabf40-2db5-484f-a94e-ed038d9634c8" noHeader="true" />  
        </div>
        <div class="col-12 col-md-3">
            <div class="q-filter" id="NaEXEv" noHeader="true" />  
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import qAPI from "../../../services/qAPI";
import page from "../../../mixins/page";
import ToggleButtons from "../../../components/ToggleButtons"

export default {
  name: "DetailedAnalysisGL",
  props: [],
  mixins: [page],
  components: {
      ToggleButtons
  },
  data() {
    return {
      pageName: this.$route.name,
      mashup: null,
      qObjects: "4e9b3947-41d4-4992-aeee-1ed9623f612f,8b73a37b-b234-4b79-924a-af23de77d4a2,15b36dd3-6c71-46fa-9e11-82d5419eb8c3,e80dc63b-7932-4185-80c0-a5355fb4548b,2246f233-78d1-472a-a686-351b3fc8777e,3456adcb-1aea-4794-bd70-75e6c43579c4,a33e3b17-97a9-4db9-8690-c363346c30b8,bfa1acaa-9377-4d78-a1cd-978b1d2492c5,bfa1acaa-9377-4d78-a1cd-978b1d2492c5,ehLUKe,49eabf40-2db5-484f-a94e-ed038d9634c8,NaEXEv",
      qFilterObjects: []
    };
  },
  async mounted() {
    await this.init(this.$route, this.qObjects, this.qFilterObjects);
  },
  async destroyed() {
    qAPI.closeQlikObjectsInStore(this.qObjects.split(","));
  },
  methods: {
    handleOptionSelected: function(option) {
      this.selectedOption = option;
    } 
  }  
};
</script>
